const assets = {
  images: {
    logoDark: require('./images/logo-dark.png'),
    logo: require("./images/logo-colour.png")
  }
};

export default assets;